import { tmpdir } from "node:os";
import { mkdtemp } from "node:fs/promises";
import path from "node:path";
import { exec } from "node:child_process";
import { promisify } from "node:util";

import pLimit from "p-limit";

import { reject } from "../../../../Common/TypingUtils";
import { FarmDirectory } from "../BuildServer/ResourcesControllers/Directories/FarmDirectory";

export type ExtractorResult = Record<string, string[] | null>;

export interface LegacyGenerator {
    getSugarTexts: (formPath: string, farmDirectory: string) => Promise<ExtractorResult>;
}

const fetchLimit = pLimit(1);
let cache: LegacyGenerator | null = null;
export const getLegacyGenerator = async (): Promise<LegacyGenerator> =>
    fetchLimit(async () => {
        if (!cache) {
            // eslint-disable-next-line require-atomic-updates
            cache = await fetchLegacyGenerator();
        }
        return cache;
    });

const execAsync = promisify(exec);
const packageName = "@kontur.candy/generator";
const packageVersion = "6.30.0"; // latest generator with `getSugarTexts`
const flags = "--no-package-lock --no-audit --no-fund";
const installCommand = `npm install ${packageName}@${packageVersion} ${flags}`;
const registry = "https://nexus.kontur.host/repository/kontur-npm-group";

export const fetchLegacyGenerator = async (): Promise<LegacyGenerator> => {
    const tmpDir = await mkdtemp(path.join(tmpdir(), "pkg-"));
    await execAsync(installCommand, { cwd: tmpDir, env: { ...process.env, NPM_CONFIG_REGISTRY: registry } });
    const modulePath = path.join(tmpDir, "node_modules", packageName);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return await import(modulePath);
};

export const resolveFormPath = async (gfv: string, farmDirectory: FarmDirectory) => {
    const suspectPath = await farmDirectory.getFormJsonPath(gfv);
    const formJsonPath = suspectPath ?? reject(`Cannot find form.json for: ${gfv}`);
    return path.join(formJsonPath, "..");
};
